export default {"src":"/_next/static/media/High_contrast_icon.ddaa4b5b.svg","height":40,"width":40};